interface IBSLAAssesorData {
    Florida: IBSLAAssesorLink;
    [key: string]: IBSLAAssesorLink
}

interface IBSLAAssesorLink {
    [key: string]: string;
    Alachua: string;
    Baker: string;
    Bay: string;
    Bradford: string;
    Brevard: string;
    Broward: string;
    Calhoun: string;
    Charlotte: string;
    Citrus: string;
    Clay: string;
    Collier: string;
    Columbia: string;
    'De Soto': string;
    Dixie: string;
    Duval: string;
    Escambia: string;
    Flagler: string;
    Franklin: string;
    Gadsden: string;
    Gilchrist: string;
    Glades: string;
    Gulf: string;
    Hamilton: string;
    Hardee: string;
    Hendry: string;
    Hernando: string;
    Highlands: string;
    Hillsborough: string;
    Holmes: string;
    'Indian River': string;
    Jackson: string;
    Jefferson: string;
    Lafayette: string;
    Lake: string;
    Lee: string;
    Leon: string;
    Levy: string;
    Liberty: string;
    Madison: string;
    Manatee: string;
    Marion: string;
    Martin: string;
    'Miami-Dade': string;
    Monroe: string;
    Nassau: string;
    Okeechobee: string;
    Orange: string;
    Osceola: string;
    'Palm Beach': string;
    Pasco: string;
    Pinellas: string;
    Polk: string;
    Putnam: string;
    'St Johns': string;
    'St Lucie': string;
    'Santa Rosa': string;
    Sarasota: string;
    Seminole: string;
    Sumter: string;
    Suwanee: string;
    Taylor: string;
    Union: string;
    Volusia: string;
    Wakulla: string;
    Walton: string;
    Washington: string;
}

const BSLAAssessorLinks: IBSLAAssesorData = {
    Florida: {
        Alachua: 'http://www.acpafl.org/ParcelResults.asp?Parcel={apn}',
        Baker: 'http://www.bakerpa.com/propertydetails.php?parcel={apn}',
        Bay: 'http://qpublic6.qpublic.net/fl_display_dw.php?county=fl_bay&KEY={apn}',
        Bradford: 'http://www.bradfordappraiser.com/GIS/Search_F.asp',
        Brevard: 'https://www.bcpao.us/propertysearch/#/account/{apn}',
        Broward: 'http://www.bcpa.net/RecInfo.asp?URL_Folio={apn}',
        Calhoun: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=829&LayerID=15004&PageTypeID=4&PageID=6750&Q=675253562&KeyValue={apn}',
        Charlotte: 'https://www.ccappraiser.com/Show_parcel.asp?acct={apn}&gen=T&tax=T&bld=T&oth=T&sal=T&lnd=T&leg=T',
        Citrus: 'https://citrus.county-taxes.com/public/real_estate/parcels/{apn}',
        Clay: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=830&LayerID=15008&PageTypeID=4&PageID=6756&Q=1935057826&KeyValue={apn}',
        Collier: 'http://www.collierappraiser.com/index.html?ref=/main_search/RecordDetail.html&FolioID={apn}',
        Columbia: 'http://ap2.columbia.floridapa.com/gis/',
        'De Soto': 'http://www.desotopa.com/gisv1/',
        Dixie: 'https://www.qpublic.net/fl/dixie/search1.html',
        Duval: 'http://apps.coj.net/PAO_PropertySearch/Basic/Detail.aspx?RE={apn}',
        Escambia: 'http://www.escpa.org/CAMA/Detail_a.aspx?s={apn}',
        Flagler: 'https://qpublic.schneidercorp.com/Application.aspx?App=FlaglerCountyFL&Layer=Parcels&PageType=Search',
        Franklin: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=816&LayerID=14540&PageTypeID=4&PageID=6407&Q=470835990&KeyValue={apn}',
        Gadsden: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=814&LayerID=14537&PageTypeID=4&PageID=6817&Q=1609062158&KeyValue={apn}',
        Gilchrist: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=820&LayerID=15174&PageTypeID=4&PageID=6883&Q=638197027&KeyValue={apn}',
        Glades: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=818&LayerID=14562&PageTypeID=2&PageID=6420',
        Gulf: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=819&LayerID=15077&PageTypeID=4&PageID=6971&Q=149672654&KeyValue={apn}',
        Hamilton: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=817&LayerID=14544&PageTypeID=4&PageID=6411&Q=35417896&KeyValue={apn}',
        Hardee: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=813&LayerID=14471&PageTypeID=4&PageID=6254&Q=1156643053&KeyValue={apn}',
        Hendry: 'http://www.hendryprop.com/GIS/',
        Hernando: 'https://www.hernandocountygis-fl.us/propertysearch/',
        Highlands: 'http://www.hcpao.org/Search#parcel',
        Hillsborough: 'http://gis.hcpafl.org/propertysearch/#/search/basic/folio={apn}',
        Holmes: 'https://qpublic.schneidercorp.com/Application.aspx?App=HolmesCountyFL&Layer=Parcels&PageType=Search',
        'Indian River': 'http://www.ircpa.org/Results.aspx?SearchType=Parcel&Criteria1={apn}',
        Jackson: 'http://qpublic6.qpublic.net/fl_display_dw.php?county=fl_jackson&KEY={apn}',
        Jefferson: 'http://search.jeffersonpa.net/gisv1/',
        Lafayette: 'http://www.lafayettepa.com/GIS/Search_F.asp',
        Lake: 'https://www.lakecopropappr.com/property-search.aspx',
        Lee: 'https://www.leepa.org/Display/DisplayParcel.aspx?STRAP={apn}',
        Leon: 'http://www.leonpa.org/pt/search/commonsearch.aspx?mode=parid',
        Levy: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=930&LayerID=18185&PageTypeID=4&PageID=8127&Q=1024816192&KeyValue={apn}',
        Liberty: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=828&LayerID=15003&PageTypeID=4&PageID=6746&Q=410713367&KeyValue={apn}',
        Madison: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=911&LayerID=17548&PageTypeID=4&PageID=7848&Q=891118490&KeyValue={apn}',
        Manatee: 'http://www.manateepao.com/ManateeFL/search/commonsearch.aspx?mode=parid',
        Marion: 'https://www.pa.marion.fl.us/PropertySearch.aspx?SearchBy=ParcelR&Parms={apn}',
        Martin: 'http://fl-martin-appraiser.governmax.com/propertymax/rover30.asp',
        'Miami-Dade': 'http://www.miamidade.gov/propertysearch/#/?folio={apn}',
        Monroe: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=605&LayerID=9946&PageTypeID=2&PageID=4381',
        Nassau: 'https://maps.nassauflpa.com/NassauSearch/ISRecentSales/NassauProperty.aspx?ParcelNumber={apn}',
        Okeechobee: 'http://www.okeechobeepa.com/GISv1/',
        Orange: 'https://www.ocpafl.org/Searches/ParcelSearch.aspx/PID/{apn}',
        Osceola: 'http://ira.property-appraiser.org/PropertySearch_services/parcelPdf/?pin={apn}',
        'Palm Beach': 'http://www.pbcgov.com/papa/Asps/PropertyDetail/PropertyDetail.aspx?parcel={apn}',
        Pasco: 'http://search.pascopa.com/',
        Pinellas: 'http://www.pcpao.org/searchpage.php',
        Polk: 'http://www.polkpa.org/CamaDisplay.aspx?OutputMode=Display&SearchType=RealEstate&ParcelID={apn}',
        Putnam: 'https://putapps.putnam-fl.com/palookup?p={apn}',
        'St Johns': 'https://qpublic.schneidercorp.com/Application.aspx?AppID=960&LayerID=21179&PageTypeID=4&PageID=9059&Q=1489543108&KeyValue={apn}',
        'St Lucie': 'http://www.paslc.org/map/propertySearch.html',
        'Santa Rosa': 'http://qpublic6.qpublic.net/fl_search_dw.php?county=fl_santarosa&search=parcel',
        Sarasota: 'http://www.sc-pa.com/propertysearch/parcel/details/{apn}',
        Seminole: 'http://parceldetail.scpafl.org/ParcelDetailInfo.aspx?PID={apn}',
        Sumter: 'http://www.sumterpa.com/GIS/',
        Suwanee: 'http://www.suwanneepa.com/GIS/Search_F.asp',
        Taylor: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=792&LayerID=11749&PageTypeID=2&PageID=5268',
        Union: 'http://union.floridapa.com/GIS/Search_F.asp',
        Volusia: 'http://publicaccess.vcgov.org/volusia/search/commonsearch.aspx?mode=realprop',
        Wakulla: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=836&LayerID=15205&PageTypeID=4&PageID=6833&Q=1268879200&KeyValue={apn}',
        Walton: 'http://qpublic6.qpublic.net/fl_display_dw.php?county=fl_walton&KEY={apn}',
        Washington: 'https://qpublic.schneidercorp.com/Application.aspx?AppID=896&LayerID=16944&PageTypeID=4&PageID=7615&Q=814059399&KeyValue={apn}'
    }
};

const BSLAGetAssesorLink = (props: { state: string; county: string; apn: string }) => {
    if (props.state in BSLAAssessorLinks && props.county in BSLAAssessorLinks[props.state]) {
        let link = BSLAAssessorLinks[props.state][props.county];
        const apn = props.apn.replace(" ", "");
        link = link.replace("{apn}", apn);

        return link;
    }

};

export default BSLAGetAssesorLink;
